import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";

const ThankYouModal = ({ open, onClose, ...rest }: any) => {
  return (
    <Dialog
      maxWidth="xs"
      open={open}
      onClose={onClose}
      {...rest}
      sx={{
        borderRadius: "50px",
      }}
    >
      <DialogTitle>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "20px",
            color: "#3D4043",
          }}
          textAlign="center"
        >
          THANK YOU
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography
          textAlign="center"
          sx={{
            fontSize: "18px",
            color: "#3D4043",
          }}
        >
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras vitae
          vestibulum neque.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ThankYouModal;
